export default __webpack_public_path__ + "static/media/con_MOVG08.8855c68e.jpg";